import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

const GROUPS = [
  { prefix: "p:", label: "Performers' mics" },
  { prefix: "i:", label: "Instruments" },
  { prefix: "t:", label: "Shared tracks" },
];

export const sourceLabel = (options, key) => options.find((o) => o.key === key)?.label || (key ? "Away" : "Empty");

export const PatchBay = ({ open, onOpenChange, mixer, options, onPatch }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-[#0f0f12] border-[#2d2d38] max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="patch-bay-dialog">
      <DialogHeader><DialogTitle>Assign channels</DialogTitle></DialogHeader>
      <p className="text-sm text-zinc-400 -mt-2">Pick what plays on each channel. Upload tracks in the Tracks tab to see them here.</p>
      <div className="grid gap-2 sm:grid-cols-2">
        {mixer.channels.map((ch, i) => (
          <label key={i} className={`flex items-center gap-3 rounded-[3px] border px-3 py-2 ${ch.source ? "border-yellow-400/50 bg-yellow-400/5" : "border-[#2d2d38]"}`}>
            <span className="mono text-xs text-yellow-300 w-10 shrink-0">CH {String(i + 1).padStart(2, "0")}</span>
            <select value={ch.source || ""} onChange={(e) => onPatch(i, { source: e.target.value || null })}
              data-testid={`patch-bay-select-ch-${i + 1}`}
              className="flex-1 min-w-0 rounded-[3px] bg-black border border-zinc-700 px-2 py-1.5 text-sm text-zinc-100 focus:border-yellow-400 outline-none">
              <option value="">— Empty —</option>
              {GROUPS.map((g) => {
                const opts = options.filter((o) => o.key.startsWith(g.prefix));
                return opts.length ? <optgroup key={g.prefix} label={g.label}>{opts.map((o) => <option key={o.key} value={o.key}>{o.label}</option>)}</optgroup> : null;
              })}
              {ch.source && !options.some((o) => o.key === ch.source) && <option value={ch.source}>Away</option>}
            </select>
          </label>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);
